module.exports = __webpack_public_path__ + "img/logo_txt.9b12d10d.png";